import React from 'react';
import { cn } from '../../../../lib/utils';
import { Card, CardContent } from '../../../ui/card';
import { MetricComparisonBlock as MetricComparisonBlockType } from '../../../../types/report-builder';

interface Props {
  block: MetricComparisonBlockType;
}

const MetricComparisonBlock: React.FC<Props> = ({ block }) => {
  return (
    <div className="my-6">
      <h3 className="mb-3 text-sm font-semibold text-foreground">{block.title}</h3>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {block.items.map((item, i) => (
          <Card key={i} className="border-border/70 bg-card shadow-[var(--shadow-card)]">
            <CardContent className="space-y-1 py-4">
              <p className="text-xs font-medium uppercase tracking-[0.05em] text-muted-foreground">
                {item.label}
              </p>
              <p className="text-xl font-bold tabular-nums text-foreground">{item.value}</p>
              {item.delta && (
                <span
                  className={cn(
                    'text-xs font-medium inline-flex items-center gap-1',
                    item.deltaDirection === 'up' && 'text-[var(--go-teal)]',
                    item.deltaDirection === 'down' && 'text-[var(--go-bittersweet)]',
                    (!item.deltaDirection || item.deltaDirection === 'neutral') && 'text-muted-foreground'
                  )}
                >
                  {item.deltaDirection === 'up' && '\u2191 '}
                  {item.deltaDirection === 'down' && '\u2193 '}
                  {item.delta}
                </span>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default MetricComparisonBlock;
